<template>
    <v-app light>
        <v-navigation-drawer 
            v-if="isAuthorized" 
            app clipped fixed 
            mobile-break-point="768"
            v-model="menuOpener" 
            width="250"
            :mini-variant="miniMenu">
            <v-list dense>
                <v-list-tile v-for="item in menuItems" :key="item.title" router :to="item.link">
                    <v-list-tile-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar app fixed clipped-left>
            <v-toolbar-side-icon v-if="isAuthorized" @click.stop="menuOpener = !menuOpener"></v-toolbar-side-icon>
            <v-btn v-if="isAuthorized" flat icon @click.native="miniMenu = !miniMenu">
                <transition fade-transition>
                    <v-icon> {{ miniMenuValue }} </v-icon>
                </transition>
            </v-btn>
            <v-toolbar-title>
                <router-link tag="span" style="cursor: pointer" to="/">
                    <v-avatar :tile=true :size="30">
                        <img src="@/assets/logo_mini.png" alt="logotype"/>
                    </v-avatar>
                    {{ title }}
                </router-link>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn v-if="isAuthorized" flat router to="/profile">
                    <v-icon left medium>account_circle</v-icon>
                    Профиль
                </v-btn>
                <v-btn v-if="isAuthorized" flat @click.native="logOut">
                    <v-icon left medium>exit_to_app</v-icon>
                    Выйти
                </v-btn>
                <v-btn v-else flat router to="/login">
                    <v-icon left medium>lock_open</v-icon>
                    Войти
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-content>
            <router-view></router-view>
        </v-content>
    </v-app>
</template>

<script>
import { AuthChecker as isAuth } from '@/utils'

export default {
	data() {
		return {
			title: 'Админка',
			menuOpener: true,
			menuItems: [{
					title: 'Панель мониторинга',
					icon: 'dashboard',
					link: '/dashboard'
				},  {
                    title: 'Пользователи',
                    icon: 'contacts',
                    link: '/user-list'
                }, {
					title: 'Справочник ЛПУ',
					icon: 'local_hospital',
					link: '/catalog-lpu'
				}, {
					title: 'Настройки',
					icon: 'settings',
					link: '/settings'
				}],
			miniMenu: true
		}
	},
	computed: {
		miniMenuValue() {
			return this.miniMenu ? 'keyboard_arrow_left' : 'keyboard_arrow_right'
		},
		isAuthorized() {
			return isAuth()
		}
	},
	methods: {
		logOut() {
			this.$store.dispatch('USER_LOGOUT')
			this.$router.push('/login')
		}
	}
}
</script>


<style lang="stylus">
@import './stylus/main';
</style>
